<script setup lang="ts">
import { XMarkIcon } from "@heroicons/vue/24/outline";

import Galbani from "@/components/logo/Galbani.vue";
import TopChef from "@/components/logo/TopChef.vue";
</script>

<template>
  <header class="flex h-20 w-full items-center justify-center gap-6 bg-black">
    <Galbani class="h-12 w-auto" />

    <XMarkIcon class="size-5 text-white" />

    <div class="flex flex-col items-end">
      <TopChef class="h-12 w-auto" />

      <span class="text-[8px] leading-[140%] font-medium text-[#B2B2B2]">
        © Bravo Media LLC 2025
      </span>
    </div>
  </header>
</template>
